import React from "react";
import { getTideCurrentInfo, roundPlaces } from "../util/util";
import { TideWindData } from "../datastructures";
import { Speed } from "./Speed";
import UnicodeSmileyFont from "./UnicodeSmiley";
import InfoOverlay from "./InfoOverlay";
import SmileyStromingsTabel from "./SmileyStromingsTabel";

interface ActueelGetijProperties {
  tideWindData: TideWindData[];
  windUnits: string;
  spotName: string;
  spotId: number;
}

export const ActueelGetij: React.FC<ActueelGetijProperties> = ({
  tideWindData,
  windUnits,
  spotName,
  spotId,
}) => {
  const tideInfo = getTideCurrentInfo(tideWindData, 0, spotId);
  if (!tideInfo) return <></>;
  const {
    upSpeedMsec,
    smiley,
    currDir,
    colorCss,
    waterLevel,
    displayTideTime,
  } = tideInfo;

  return (
    <>
      <li>
        Getij info {spotName} ({displayTideTime}):
        <ul>
          <li>
            Stroming in windrichting:{" "}
            <span style={colorCss}>
              <Speed value={Math.abs(upSpeedMsec)} fractionDigits={2} />{" "}
              {currDir} <UnicodeSmileyFont smiley={smiley} />
            </span>
            <InfoOverlay>
              <SmileyStromingsTabel windUnits={windUnits} />
              <p>
                De getallen hier geven alleen het deel van de strooming tegen de
                wind in{" "}
                <b>
                  Gebruik deze informatie dus niet voor het inschatten van
                  veiligheidsrisico&#39;s
                </b>
                <p>
                  Voor meer informatie over deze getallen zie ook de info knop
                  bij de &quot;Stroomsnelheid tegen de wind in...&quot; grafiek
                  onder.
                </p>
              </p>
            </InfoOverlay>
          </li>
          <li>Waterstand: {roundPlaces(waterLevel, 2)} m</li>
        </ul>
      </li>
    </>
  );
};
